import React, {Component} from 'react';
import {connect} from 'react-redux';

// Components
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';
import Anchor from 'Components/common/Anchor';

class AssignmentCustomerCard extends Component {
    state = {
        num: 0,
        convertPackageDialogOpened: false,
        currentInventroyDetails: {},
        numberSteps: 1,
    };

    componentWillMount() {}

    showTaskStatus = (item) => {
        let taskStatusFlag = '';

        if (item.taskStatus === 'submitted') {
            taskStatusFlag = 'task_details_p_submit';
        } else if (item.taskStatus === 'completed') {
            taskStatusFlag = 'user_center_task_management_all_completed';
        }

        return taskStatusFlag;
    };

    render() {
        const {item, localData, chooseItem} = this.props;
        const {} = this.state;

        return (
            <Anchor
                className="assignment-customer-card"
                onClickOfSingleTap={chooseItem}>
                <div className="sub-group-left">
                    {item.taskStatus === 'progress' ? (
                        <h6 className="my-task-progess-status">
                            <div className="progess-status-style">
                                {T('task_management_progress_task_label')}
                            </div>
                            <div className="ongoing-progess-content">
                                {item.trackingStatus}
                            </div>
                        </h6>
                    ) : null}
                    {item.stAlphaName ? (
                        <div className="institution-name">
                            <div className="sub-group-left">
                                {item.stAlphaName}
                            </div>
                            <div className="sub-group-right">
                                {item.required
                                    ? T('task_management_mandatory')
                                    : T('task_management_non_mandatory')}
                            </div>
                        </div>
                    ) : null}
                    <div className="deadline-content">
                        {item.required
                            ? T('task_details_please_complete', [item.endDate])
                            : T(
                                  'task_details_please_non_mandatory_complete_date',
                                  [item.endDate],
                              )}
                        {!item.stAlphaName ? (
                            <div className="sub-group-right">
                                {item.required
                                    ? T('task_management_mandatory')
                                    : T('task_management_non_mandatory')}
                            </div>
                        ) : null}
                    </div>

                    {this.showTaskStatus(item) ? (
                        <div
                            className={
                                item.taskStatus === 'progress'
                                    ? 'task-status progress-task'
                                    : 'task-status'
                            }>
                            {T(this.showTaskStatus(item))}
                        </div>
                    ) : null}
                </div>
            </Anchor>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, inventoryQuery} = state;

    return {
        productManagementListLoaded: inventoryQuery.productManagementListLoaded,
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AssignmentCustomerCard);
